(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 6045:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8669);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./pages/Home.module.css
var Home_module = __webpack_require__(2145);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/leftSideBar/leftSideBar.tsx
var leftSideBar = __webpack_require__(4899);
// EXTERNAL MODULE: ./components/header/header.tsx + 3 modules
var header = __webpack_require__(4593);
// EXTERNAL MODULE: ./components/homeBody/homeBody.module.css
var homeBody_module = __webpack_require__(6305);
var homeBody_module_default = /*#__PURE__*/__webpack_require__.n(homeBody_module);
;// CONCATENATED MODULE: ./components/homeBody/homeBody.tsx


function HomeBody(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (homeBody_module_default()).HomeBodyMain
    });
};

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./common/constants/index.ts
var constants = __webpack_require__(9813);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/index.tsx








function Home() {
    var ref = (0,react.useState)(true), sideBarOpen = ref[0], setSideBarOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Sports Fever - Home"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Home_module_default()).HomeMainDiv,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(leftSideBar/* default */.Z, {
                        sideBarOpen: sideBarOpen,
                        setSideBarOpen: function() {
                            return setSideBarOpen(!sideBarOpen);
                        },
                        pageName: constants/* PageNames.home */.sn.home
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        setSideBarOpen: function() {
                            return setSideBarOpen(!sideBarOpen);
                        },
                        sideBarOpen: sideBarOpen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBody, {
                        sideBarOpen: sideBarOpen
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HomeBodyMain":"homeBody_HomeBodyMain__DGFSK","HomeBodyMainSideBarOpen":"homeBody_HomeBodyMainSideBarOpen__jFjQV"};

/***/ }),

/***/ 2145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HomeMainDiv":"Home_HomeMainDiv__JKnsz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [202,224,774,888,179], function() { return __webpack_exec__(6045); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);